import { SimulationCaseById } from "__generated__/types";
import { Button } from "common/buttons";
import { LoadingLayout } from "common/components/layouts/LoadingLayout";
import { NoDataError } from "common/components/NoDataError";
import { SimpleTabsVertical } from "common/components/tabs/SimpleTabsVertical";
import React, { useState } from "react";
import styles from "./Simulation.module.css";

type CaseProps = {
  data: SimulationCaseById;
  displayReferral?: boolean;
};

export const Examination: React.FC<CaseProps> = ({
  data,
  displayReferral = true,
}) => {
  const [notificationMessage, setNotificationMessage] = useState<string | null>(
    null,
  );
  const [instantReferralClicked, setInstantReferralClicked] =
    useState<boolean>(false);

  if (!data.simulationCaseById || !data.simulationCaseById.assessments) {
    return (
      <LoadingLayout>
        <NoDataError />
      </LoadingLayout>
    );
  }

  const { id, referral, assessments, instantReferral } =
    data.simulationCaseById;

  const content = assessments.map((assessment) => ({
    title: assessment?.testName ?? "",
    content: assessment?.testResult ?? "",
  }));

  const handleInstantReferralClick = () => {
    if (instantReferral?.referralValue) {
      setNotificationMessage(
        "Det var riktig, pasienten skal henvises umiddelbart.",
      );
    } else {
      setNotificationMessage(
        "Det var dessverre ikke riktig, pasient skulle ikke vært henvist umiddelbart.",
      );
    }
    setInstantReferralClicked(true);
  };

  const handleStartOver = () => {
    setNotificationMessage(null);
    setInstantReferralClicked(false);
  };

  return (
    <>
      <div className={styles.fullHeader} />
      {!instantReferralClicked ? (
        <div className={styles.tabs}>
          <div className={styles.titleContainer}>
            <p style={{ fontStyle: "oblique", maxHeight: "60vh" }}>
              Utfør undersøkelser og få informasjon om pasienten
            </p>
            <SimpleTabsVertical
              extraTabListItemClassName={styles.tabListItems}
              extraTabListClassName={styles.verticalTabs}
              tabListContainerClassName={styles.tabContainer}
              extraTabPanelClassName={styles.tabContent}
              content={content}
            />
          </div>
          {displayReferral && (
            <div>
              <p style={{ fontStyle: "oblique", marginBottom: 30 }}>
                Send pasient videre
              </p>
              {instantReferral?.referralContent == "Ingen henvisning" ? (
                <Button className={styles.tabListItem}>
                  {referral && referral.length > 0
                    ? instantReferral.referralContent
                    : ""}
                </Button>
              ) : (
                <Button
                  className={styles.tabListItem}
                  onClick={handleInstantReferralClick}
                >
                  {referral && referral.length > 0
                    ? instantReferral?.referralContent
                    : ""}
                </Button>
              )}
            </div>
          )}
        </div>
      ) : (
        <div className={styles.notificationMessageContainer}>
          {instantReferral?.referralValue ? (
            <p style={{ color: "green" }}>{notificationMessage} </p>
          ) : (
            <p style={{ color: "red" }}>
              {notificationMessage}{" "}
              <span
                onClick={handleStartOver}
                onKeyDown={(e) => {
                  e.key === "Enter" && handleStartOver();
                }}
                role="button"
                tabIndex={0}
                style={{ textDecoration: "underline", cursor: "pointer" }}
              >
                Start på nytt.
              </span>
            </p>
          )}
        </div>
      )}
    </>
  );
};
